import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import Iconify from "../../components/iconify";
import { useLocation, useNavigate } from "react-router-dom";
import { PATH_AUTH } from "../../routes/paths";
import Logo from "../../components/logo";
import useResponsive from "../../hooks/useResponsive";

function Header() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isDesktop = useResponsive("up", "md");

  return (
    <Stack
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      py={2}
      px={4}
    >
      <Logo />
    </Stack>
  );
}

export default Header;
